// Activity feed shared strings — EN + TR.
//
// Wave-1 Day 3 wiring. Cross-shell consumed (admin/seller/supply ActivityFeed
// component all use the same dict). CATEGORY_LABEL is load-bearing — keys
// mirror the ActivityCategory enum (iq1/iq2/iq7/supply/b2b/feedback/...).
//
// Per-shell wording variant: scope label flips based on shell prop (admin
// scope = "All activity (Ring 3 admin audit governance)"; seller/supply
// scope = "Your org activity").

import type { LocalizedDict } from '../index'

type ActivityFeedStrings = {
  title: string
  loading: string
  error: string
  empty: string
  scopeAdmin: string
  scopeOrg: string
  filterLabel: string
  limitLabel: string
  allCategories: string
  recordsSuffix: string
  auditCalloutLead: string
  auditCalloutBody: string
  categoryLabels: {
    iq1: string
    iq2: string
    iq7: string
    supply: string
    b2b: string
    feedback: string
    inventory: string
    orders: string
    onboarding: string
    catalog: string
    governance: string
  }
}

export const activityFeedI18n: LocalizedDict<ActivityFeedStrings> = {
  en: {
    title: 'Activity',
    loading: 'Loading activity log…',
    error: 'Activity data could not be loaded.',
    empty: 'No activity records match this filter.',
    scopeAdmin: 'All activity (Ring 3 admin audit governance)',
    scopeOrg: 'Your org activity',
    filterLabel: 'Filter:',
    limitLabel: 'Limit:',
    allCategories: 'All categories',
    recordsSuffix: 'records',
    auditCalloutLead: 'A-25 audit log:',
    auditCalloutBody:
      'Every mutation (state transition, approve/reject, allocate, submit) is persisted to the audit_events table. M3 SPEC.md Faz 1 schema commit; cross-cutting G-1 5 new event_type categories extension in Faz 6.',
    categoryLabels: {
      iq1: 'Pending Updates',
      iq2: 'Vendor Replacement',
      iq7: 'Assortment',
      supply: 'Supply',
      b2b: 'B2B Push',
      feedback: 'Catalog Issue',
      inventory: 'Inventory',
      orders: 'Orders',
      onboarding: 'Onboarding',
      catalog: 'Catalog',
      governance: 'Governance',
    },
  },
  tr: {
    title: 'Aktivite',
    loading: 'Aktivite günlüğü yükleniyor…',
    error: 'Aktivite verisi yüklenemedi.',
    empty: 'Bu filtre için aktivite kaydı yok.',
    scopeAdmin: 'Tüm aktiviteler (Ring 3 admin audit governance)',
    scopeOrg: 'Kendi org aktivitelerin',
    filterLabel: 'Filtre:',
    limitLabel: 'Limit:',
    allCategories: 'Tüm kategoriler',
    recordsSuffix: 'kayıt',
    auditCalloutLead: 'A-25 audit log:',
    auditCalloutBody:
      'Her mutation (state transition, approve/reject, allocate, submit) audit_events tablosuna persist edilir. M3 SPEC.md Faz 1\'de schema commit; cross-cutting G-1 5 yeni event_type kategori extension Faz 6.',
    categoryLabels: {
      iq1: 'Bekleyen Güncellemeler',
      iq2: 'Tedarikçi Değişimi',
      iq7: 'Asortiment',
      supply: 'Tedarik',
      b2b: 'B2B Gönderim',
      feedback: 'Katalog Sorunu',
      inventory: 'Envanter',
      orders: 'Siparişler',
      onboarding: 'Karşılama',
      catalog: 'Katalog',
      governance: 'Yönetişim',
    },
  },
}
